import { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { getCurrentUser } from "../service/callAPI";

function ProtectedRoute({
	component: Component,
	...rest
}: {
	component: any;
	[key: string]: any;
}) {
	const [isAuthenticated, setIsAuth] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		getCurrentUser()
			.then((user) => {
				if (user && user.id) {
					setIsAuth(true);
					setIsLoading(false);
					return;
				}
				setIsAuth(false);
				setIsLoading(false);
			})
			.catch(() => {
				setIsAuth(false);
				setIsLoading(false);
			});
	}, []);
	if (isLoading) {
		return null;
	}

	return isAuthenticated ? (
		<Route {...rest}>
			<Component />
		</Route>
	) : (
		<Redirect to="/login" />
	);
}

export default ProtectedRoute;
